module.exports = {
  getNews: (req, res) => {
    return [
      {
        "title": "Warner Bros. Discovery split throws the future of TNT Sports into question",
        "link": "https://www.cnbc.com/2025/06/09/wbd-split-tnt-sports-rights.html",
        "snippet": "Warner Bros. Discovery CEO David Zaslav suggests TNT Sports may move away from HBO Max in the future.",
        "photo_url": "https://image.cnbcfm.com/api/v1/image/107350540-17031702132023-06-13t012645z_618735051_rc21i1ambypf_rtrmadp_0_film-the-flash-premiere.jpeg?v=1703170275&w=1600&h=900",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNTBXREp6YjNOc1JFdDNWRFp0VFJDZkF4ampCU2dLTWdhbFZZak5yUVE=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T16:07:37.000Z",
        "authors": [
          "Alex Sherman"
        ],
        "source_url": "https://www.cnbc.com",
        "source_name": "CNBC",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://www.cnbc.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIQgKIhtDQklTRGdnTWFnb0tDR051WW1NdVkyOXRLQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZ0ZG5RMWVEQXhOQklDWlc0b0FBUAE",
            "topic_name": "Alex Sherman"
          }
        ]
      },
      {
        "title": "Fox Sports Taking Heat for Its Terry Bradshaw Decision",
        "link": "https://sports.yahoo.com/article/fox-sports-taking-heat-terry-180810025.html",
        "snippet": "\"NBC Sports needs the entire Triple Crown. Fox Sports is bad. Terry Bradshaw bad,\" another horse racing fan said. FOX may not be the preferred ...",
        "photo_url": "https://s.yimg.com/ny/api/res/1.2/NF9_VeniceeYgUvVQxnE7Q--/YXBwaWQ9aGlnaGxhbmRlcjt3PTY0MDtoPTQyNztjZj13ZWJw/https://media.zenfs.com/en/men_s_journal_718/3f33fa64acab259c5b64d64388d87586",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNUhNSGxFV1dsVGJtSnJNMVI0VFJDckF4aUFCU2dLTWdheFU0SndKUWM=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-08T18:08:10.000Z",
        "authors": [
          "Kameron Duncan"
        ],
        "source_url": "https://sports.yahoo.com",
        "source_name": "Yahoo Sports",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://sports.yahoo.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqLAgKIiZDQklTRmdnTWFoSUtFSE53YjNKMGN5NTVZV2h2Ynk1amIyMG9BQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEYwZUcwMGF6azRNaElDWlc0b0FBUAE",
            "topic_name": "Kameron Duncan"
          }
        ]
      },
      {
        "title": "Sports betting is legal and growing more popular. Harassment of athletes by angry gamblers is rising too",
        "link": "https://www.cnn.com/2025/06/09/sport/athlete-abuse-betting-sport-intl",
        "snippet": "Sports betting is legal and growing more popular. Harassment of athletes by angry gamblers is rising too. By Amy Woodyatt, CNN. 6 minute ...",
        "photo_url": "https://media.cnn.com/api/v1/images/stellar/prod/gettyimages-2218012970.jpg?c=16x9&q=h_833,w_1480,c_fill",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNVFkMjF1U0dGelZVbEtSVk5yVFJDZkF4amlCU2dLTWdhdEJJeXVFUXM=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T10:00:00.000Z",
        "authors": [
          "Amy Woodyatt"
        ],
        "source_url": "https://www.cnn.com",
        "source_name": "CNN",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.cnn.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIAgKIhpDQklTRFFnTWFna0tCMk51Ymk1amIyMG9BQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZtZEdOdWVUSjJlaElDWlc0b0FBUAE",
            "topic_name": "Amy Woodyatt"
          }
        ]
      },
      {
        "title": "Loss of over-the-air TV leaves some Chicago sports fans frustrated with new CHSN-Comcast deal",
        "link": "https://www.chicagotribune.com/2025/06/09/chsn-comcast-deal-ends-free-tv/",
        "snippet": "When the Chicago Sports Network went live Oct. 1, it didn't have a deal to be carried by Comcast, the market's largest pay-TV provider.",
        "photo_url": "https://www.chicagotribune.com/wp-content/uploads/2025/03/CTC-L-SOX-ANGELS-fans18_225099016.jpg?w=528",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNTNVRTVJY0VadVR6WmtTVEpUVFJEZUFoaVFCQ2dLTWdZQk1JckxuQWc=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T22:18:58.000Z",
        "authors": [
          "Robert Channick"
        ],
        "source_url": "https://www.chicagotribune.com",
        "source_name": "Chicago Tribune",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://www.chicagotribune.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqLggKIihDQklTR0FnTWFoUUtFbU5vYVdOaFoyOTBjbWxpZFc1bExtTnZiU2dBUAE",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZuT1hKaU9HeHJPQklDWlc0b0FBUAE",
            "topic_name": "Robert Channick"
          }
        ]
      },
      {
        "title": "Palestine’s World Cup dream still on as Israel ruins Gaza’s sports sector",
        "link": "https://www.aljazeera.com/sports/2025/6/9/palestines-world-cup-dream-still-on-as-israel-ruins-gazas-sports-sector",
        "snippet": "According to the Palestinian Olympic Committee, 582 athletes have been killed since October 7, 2023, many of them national team players, coaches ...",
        "photo_url": "https://www.aljazeera.com/wp-content/uploads/2025/06/Youssef-Abu-Shwareb-the-goalkeeper-tries-to-hold-onto-an-exercising-schedule-as-much-as-possible-despite-the-carnage.-Image-by-Mohamed-Solaimane.-1749467823_3f6ccb-1749484061.jpg?resize=1200%2C630&quality=80",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNU9lSEIwWTFCSlEzaGpOWE53VFJDUkF4ajhCU2dLTWdZWlFKQUtKZ2c=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T16:51:12.000Z",
        "authors": [],
        "source_url": "https://www.aljazeera.com",
        "source_name": "Al Jazeera",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://www.aljazeera.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKAgKIiJDQklTRXdnTWFnOEtEV0ZzYW1GNlpXVnlZUzVqYjIwb0FBUAE",
        "related_topics": []
      },
      {
        "title": "Rugby’s breakaway R360 league labelled ‘delusional’ by leading TV sport executive",
        "link": "https://www.theguardian.com/sport/2025/jun/09/premiership-r360-delusional-tnt-sports-wbd-rugby-union",
        "snippet": "Rugby's breakaway R360 league labelled 'delusional' by leading TV sport executive · R360 targeting 'best of the best' 300 male players.",
        "photo_url": "https://i.guim.co.uk/img/media/1e5f2e84a9b003f7f273f98f1da7af3edb12fa15/407_380_4389_3510/master/4389.jpg?width=465&dpr=1&s=none&crop=none",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNVRVVloyY2pKWVdVRjNWa0prVFJEMEFoalJBeWdLTWdhaEpJck5JUWM=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T17:00:00.000Z",
        "authors": [
          "Gerard Meagher"
        ],
        "source_url": "https://www.theguardian.com",
        "source_name": "The Guardian",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://www.theguardian.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKggKIiRDQklTRlFnTWFoRUtEM1JvWldkMVlYSmthV0Z1TG1OdmJTZ0FQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZtTUhsdWVUbG1aQklDWlc0b0FBUAE",
            "topic_name": "Gerard Meagher"
          }
        ]
      },
      {
        "title": "Athletics and Learfield Launch Buckeye Sports Group",
        "link": "https://ohiostatebuckeyes.com/news/2025/6/9/general-athletics-and-learfield-launch-buckeye-sports-group",
        "snippet": "Groundbreaking initiative will elevate student-athlete NIL opportunities & maximize earning potential. COLUMBUS, Ohio – The Ohio State ...",
        "photo_url": "https://images.sidearmdev.com/resize?url=https%3A%2F%2Fdxbhsrqyrr690.cloudfront.net%2Fsidearm.nextgen.sites%2Fohiostatebuckeyes.com%2Fimages%2F2019%2F10%2Ffacility-aerials-9.jpg&height=300&type=webp",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNDRia05zY1c1T2JrRnFVVzVwVFJEQ0FSaURBaWdCTWdZQmNJYlN4QVE=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T16:36:58.000Z",
        "authors": [],
        "source_url": "https://ohiostatebuckeyes.com",
        "source_name": "Ohio State | Official Athletics Website",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://ohiostatebuckeyes.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMggKIixDQklTR3dnTWFoY0tGVzlvYVc5emRHRjBaV0oxWTJ0bGVXVnpMbU52YlNnQVAB",
        "related_topics": []
      },
      {
        "title": "Are boys sports declining? Former Pacers star, others seek solutions",
        "link": "https://www.usatoday.com/story/sports/2025/06/08/antonio-davis-boys-sports-project-play/84087092007/",
        "snippet": "Are boys sports declining? Former Pacers star, others seek solutions. How do we get more boys to play sports and keep them involved? Portrait of ...",
        "photo_url": "https://www.usatoday.com/gcdn/authoring/authoring-images/2025/06/07/USAT/84090175007-19990227-t-000000-z-1070791608-rp-1-drihqsiaa-rtrmadp-3-sportnba.JPG?crop=2046,1151,x0,y142&width=660&height=371&format=pjpg&auto=webp",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNUJlazQxYVhVNVlXNXBSVXQzVFJEekFoaVVCU2dLTWdhQlFJck5HUW8=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-08T10:06:08.000Z",
        "authors": [
          "Stephen Borelli"
        ],
        "source_url": "https://www.usatoday.com",
        "source_name": "USA Today",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://www.usatoday.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJggKIiBDQklTRWdnTWFnNEtESFZ6WVhSdlpHRjVMbU52YlNnQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqJggKIiBDQkFTRWdvTUwyY3ZNVEV6ZERNMWVUSnRFZ0psYmlnQVAB",
            "topic_name": "Stephen Borelli"
          }
        ]
      },
      {
        "title": "Athletes express concern over NCAA settlement’s impact on non-revenue sports",
        "link": "https://apnews.com/article/ncaa-settlement-7aab7a3f3ee0a045b1cf1ce69e029b45",
        "snippet": "The $2.8 billion NCAA settlement is being touted as a path to stability for college sports, clearing the way for schools to pay their ...",
        "photo_url": "https://dims.apnews.com/dims4/default/3d1a29f/2147483647/strip/true/crop/4329x2886+0+0/resize/599x399!/quality/90/?url=https%3A%2F%2Fassets.apnews.com%2F29%2F69%2F27c6638b90f5919ad7f7f37363bc%2F807591438b964d42865c1672ccee7b90",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNTNZV3hvY0djMGJUbG1iR0V3VFJDUEF4alhCQ2dLTWdhbEpaYk5GUW8=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T21:00:00.000Z",
        "authors": [],
        "source_url": "https://apnews.com",
        "source_name": "AP News",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://apnews.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJAgKIh5DQklTRUFnTWFnd0tDbUZ3Ym1WM2N5NWpiMjBvQUFQAQ",
        "related_topics": []
      },
      {
        "title": "Club and Intramural Sports",
        "link": "https://www.umassd.edu/student-life/club-and-intramural-sports/",
        "snippet": "Club and intramural sports are the perfect fit for busy UMassD students who want to stay in the game—on their own terms. Ready to play? Sign up ...",
        "photo_url": "https://www.umassd.edu/media/supportingfiles/layoutassets/images/homepage/april/171003-entrance-sign-tjc-004-md.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNVNlbDlZTlZOdlpXVmxZa05KVFJDZkF4ampCU2dLTWdhaHBKTE1PUWM=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T21:06:23.000Z",
        "authors": [],
        "source_url": "https://www.umassd.edu",
        "source_name": "UMass Dartmouth",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.umassd.edu&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJAgKIh5DQklTRUFnTWFnd0tDblZ0WVhOelpDNWxaSFVvQUFQAQ",
        "related_topics": []
      },
      {
        "title": "Today's NYT Connections: Sports Edition Hints and Answers for June 10, #260",
        "link": "https://www.cnet.com/tech/gaming/todays-nyt-connections-sports-edition-hints-and-answers-for-june-10-260/",
        "snippet": "Yellow group: Baseball pitches that end in \"ball.\" Green group: Ways to take in a sporting event. Blue group: Chargers QBs, past and present.",
        "photo_url": "https://www.cnet.com/a/img/resize/bb6ef58f95ffd7fba593743a7ced832a81ff6174/hub/2024/10/16/4760818b-20b7-4bf9-b957-a057dbae5fc8/connections-sports-edition-6855.jpg?auto=webp&fit=crop&height=675&width=1200",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNDNkME5uVUhwVlEyRnZaMUowVFJDZkF4ampCU2dLTWdZZGxKQ3ROUVk=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T20:00:00.000Z",
        "authors": [
          "Gael Fashingbauer Cooper"
        ],
        "source_url": "https://www.cnet.com",
        "source_name": "CNET",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://www.cnet.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIQgKIhtDQklTRGdnTWFnb0tDR051WlhRdVkyOXRLQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqJggKIiBDQkFTRWdvTUwyY3ZNV2hqYzNnMVl6QTVFZ0psYmlnQVAB",
            "topic_name": "Gael Fashingbauer Cooper"
          }
        ]
      },
      {
        "title": "SPORTS SPOTLIGHT: Lani Gilmore",
        "link": "https://marbleheadcurrent.org/2025/06/09/sports-spotlight-lani-gilmore/",
        "snippet": "NAME: Lani Gilmore. AGE: 18. FAMILY: Mom, Maile; dad, Adam; Siblings: Dylan, 18; Hailey, 15; Callie, 15. SCHOOL YEAR: Senior.",
        "photo_url": "https://i0.wp.com/marbleheadcurrent.org/wp-content/uploads/2025/06/lani-gilmore-1-1.jpeg?resize=279%2C300&ssl=1",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNXZTMnRZWmxKNlpXaEhZM1ZpVFJDc0FoaVhBaWdLTWdZaEpvanNHUW8=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T18:29:36.000Z",
        "authors": [],
        "source_url": "https://marbleheadcurrent.org",
        "source_name": "Marblehead Current",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://marbleheadcurrent.org&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMggKIixDQklTR3dnTWFoY0tGVzFoY21Kc1pXaGxZV1JqZFhKeVpXNTBMbTl5WnlnQVAB",
        "related_topics": []
      },
      {
        "title": "1 arrested following fight at Pueblo sports complex",
        "link": "https://www.kktv.com/2025/06/09/1-arrested-following-fight-pueblo-sports-complex/",
        "snippet": "Two adults were injured and one person was arrested following a fight Sunday night at Runyon Field Sports Complex, according to the Pueblo ...",
        "photo_url": "https://gray-kktv-prod.gtv-cdn.com/resizer/v2/UJYIAV4GXJC6DFUFSK6D6TV3CY.png?auth=c5f7b3cee6374a897eb0ac5ca788279f6e0143f08252f9a611de340f3b5f463e&width=1200&height=600&smart=true",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNWlhelpuZFZKR1JVNDNVSEJCVFJDSEF4aVBCaWdLTWdhdEJZRE5OUVk=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T22:08:00.000Z",
        "authors": [
          "Aspen Andrews"
        ],
        "source_url": "https://www.kktv.com",
        "source_name": "KKTV",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.kktv.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIQgKIhtDQklTRGdnTWFnb0tDR3RyZEhZdVkyOXRLQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZxZWpBMWEzaG5lQklDWlc0b0FBUAE",
            "topic_name": "Aspen Andrews"
          }
        ]
      },
      {
        "title": "Mid-Ohio Valley Sports Announcements",
        "link": "https://www.newsandsentinel.com/news/community-news/2025/06/mid-ohio-valley-sports-announcements-123/",
        "snippet": "The 2025 Summer All-Comer Track Meets will be held June 12 and June 19 at 6:30 p.m. at Belpre High School. Entry fee is $10 per participant for ...",
        "photo_url": "https://ogden_images.s3.amazonaws.com/www.newsandsentinel.com/images/2024/02/09222227/ImageSports-1100x733.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iL0NnNHpTVVJxVm5KS1pYQkxTVzlMVFJERUF4aW1CU2dLTWdtQlVZaUdPU1JGeVFF=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T04:05:29.000Z",
        "authors": [],
        "source_url": "https://www.newsandsentinel.com",
        "source_name": "News and Sentinel",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://www.newsandsentinel.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMAgKIipDQklTR1FnTWFoVUtFMjVsZDNOaGJtUnpaVzUwYVc1bGJDNWpiMjBvQUFQAQ",
        "related_topics": []
      },
      {
        "title": "Nominations for the RIT Sports Hall of Fame Class of 2025 now being accepted",
        "link": "https://ritathletics.com/news/2025/6/9/general-nominations-for-the-rit-sports-hall-of-fame-class-of-2025-now-being-accepted.aspx",
        "snippet": "A former athlete must be a certified graduate of the Institute to include bachelor's and/or associate's degrees. The athlete becomes eligible ...",
        "photo_url": "https://ritathletics.com/images/2025/6/9/H_F_Noms_2025_7411385.png",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNTRRVzB6YmxSRU9VTndUa2t0VFJDb0FSaXNBaWdCTWdZTmNvcm51QVE=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T16:27:31.000Z",
        "authors": [],
        "source_url": "https://ritathletics.com",
        "source_name": "Rochester Institute of Technology Athletics",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://ritathletics.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqLAgKIiZDQklTRmdnTWFoSUtFSEpwZEdGMGFHeGxkR2xqY3k1amIyMG9BQVAB",
        "related_topics": []
      },
      {
        "title": "Multiple sports the reason for Vukovich's rise",
        "link": "https://www.kolotv.com/2025/06/10/multiple-sports-reason-vukovichs-rise/",
        "snippet": "Reno Aces utility player AJ Vukovich blends his background in multiple sports to help the club win games. On Opening Day Vukovich made two ...",
        "photo_url": "https://gray-kolo-prod.gtv-cdn.com/resizer/v2/DPS4CGNWPFHRVEYCXRMMR37WDM.jpg?auth=b7b1574989cae210878d20ce83e3689d20ec27214f6ab8cccf54d6021b41dafc&width=1200&height=600&smart=true",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNUhSbEpUVkhrd2FWZGZSVGw1VFJDSEF4aVBCaWdLTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T00:40:00.000Z",
        "authors": [
          "Kurt Schroeder"
        ],
        "source_url": "https://www.kolotv.com",
        "source_name": "KOLO | 8 News Now",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://www.kolotv.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJAgKIh5DQklTRUFnTWFnd0tDbXR2Ykc5MGRpNWpiMjBvQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZvWTNsc2FtZ3hZeElDWlc0b0FBUAE",
            "topic_name": "Kurt Schroeder"
          }
        ]
      },
      {
        "title": "Sports Marketing Captures Two National Awards",
        "link": "https://hawaiiathletics.com/news/2025/6/9/general-sports-marketing-captures-two-national-awards.aspx",
        "snippet": "Marking three consecutive years the department has been recognized by NACMA with national awards, including four awards over the last three ...",
        "photo_url": "https://hawaiiathletics.com/images/2025/6/9/IMG_2345.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNXpOVmRwYkRKT1FtVkdVVXhHVFJDb0FSaXNBaWdCTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T23:19:32.000Z",
        "authors": [],
        "source_url": "https://hawaiiathletics.com",
        "source_name": "Hawaii Athletics",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://hawaiiathletics.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMAgKIipDQklTR1FnTWFoVUtFMmhoZDJGcGFXRjBhR3hsZEdsamN5NWpiMjBvQUFQAQ",
        "related_topics": []
      },
      {
        "title": "NCAA will pay its current and former athletes in an agreement that will transform college sports",
        "link": "https://theconversation.com/ncaa-will-pay-its-current-and-former-athletes-in-an-agreement-that-will-transform-college-sports-256178",
        "snippet": "After a lengthy litigation process, the NCAA has agreed to provide US$2.8 billion in back pay to former and current college athletes, while ...",
        "photo_url": "https://images.theconversation.com/files/666779/original/file-20250508-56-2mu7wa.jpg?ixlib=rb-4.1.0&rect=0%2C0%2C3000%2C2000&q=20&auto=format&w=320&fit=clip&dpr=2&usm=12&cs=strip",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iL0NnNDNlbTVzZVU1NFNIbDJPR1JUVFJDM0FSaVRBaWdCTWdtQlFJakZyT1poY3dF=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T12:23:24.000Z",
        "authors": [
          "Joshua Lens"
        ],
        "source_url": "https://theconversation.com",
        "source_name": "The Conversation",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://theconversation.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMAgKIipDQklTR1FnTWFoVUtFM1JvWldOdmJuWmxjbk5oZEdsdmJpNWpiMjBvQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEYzWm5wNWJtZG5iUklDWlc0b0FBUAE",
            "topic_name": "Joshua Lens"
          }
        ]
      },
      {
        "title": "Athletic Year in Review: Fall Sports Team’s Success Jumpstarts Successful 2024-2025 Athletic Season",
        "link": "https://wucardinals.com/news/2025/6/9/general-athletic-year-in-review-fall-sports-teams-success-jumpstarts-successful-2024-2025-athletic-season.aspx",
        "snippet": "Wheeling, W. Va. – The 2024-2025 season marked the 73rd season of Wheeling Athletics with a department record 22 varsity sports competing.",
        "photo_url": "https://wucardinals.com/images/2025/6/9/BSF_Side.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iJ0NnNHhja2hZVkV0UFNXOURVVVJWVFJDb0FSaXNBaWdCTWdNQm9BQQ=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T21:27:12.000Z",
        "authors": [],
        "source_url": "https://wucardinals.com",
        "source_name": "Wheeling University Athletics",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://wucardinals.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKggKIiRDQklTRlFnTWFoRUtEM2QxWTJGeVpHbHVZV3h6TG1OdmJTZ0FQAQ",
        "related_topics": []
      },
      {
        "title": "Marlins star Eury Pérez makes first MLB start since 2023, unveils new arsenal in loss to Pirates",
        "link": "https://www.cbssports.com/mlb/news/marlins-star-eury-perez-makes-first-mlb-start-since-2023-unveils-new-arsenal-in-loss-to-pirates/",
        "snippet": "Miami Marlins right-hander Eury Pérez returned to a big-league mound on Monday night against the Pittsburgh Pirates for the first time since ...",
        "photo_url": "https://sportshub.cbsistatic.com/i/2025/06/09/6a3068b7-94f6-47c2-8fd8-b390fc90f1c9/perez-getty.png",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNWlSVVpSY0dGdVJuaFlUbEpWVFJDZkF4amlCU2dLTWdZeFZKQ1FMUWM=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T02:13:00.000Z",
        "authors": [
          "Dayn Perry",
          "R.J. Anderson"
        ],
        "source_url": "https://www.cbssports.com",
        "source_name": "CBS Sports",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.cbssports.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKAgKIiJDQklTRXdnTWFnOEtEV05pYzNOd2IzSjBjeTVqYjIwb0FBUAE",
        "related_topics": [
          {
            "topic_id": "CAAqIggKIhxDQkFTRHdvSkwyMHZNR0p6T0d4ckVnSmxiaWdBUAE",
            "topic_name": "Dayn Perry"
          },
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZzWjNGeWVYUTVhQklDWlc0b0FBUAE",
            "topic_name": "R.J. Anderson"
          }
        ]
      },
      {
        "title": "Sports on TV: Tuesday, June 10, 2025",
        "link": "https://www.miamiherald.com/sports/sports-on-the-air/article308195590.html",
        "snippet": "Sports on TV: Tuesday, June 10, 2025 · 'Dan Le Batard Show With Stugotz' reveals new partnership and 20th anniversary plans · Sports on TV: ...",
        "photo_url": null,
        "thumbnail_url": null,
        "published_datetime_utc": "2025-06-10T05:00:00.000Z",
        "authors": [],
        "source_url": "https://www.miamiherald.com",
        "source_name": "Miami Herald",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://www.miamiherald.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKggKIiRDQklTRlFnTWFoRUtEMjFwWVcxcGFHVnlZV3hrTG1OdmJTZ0FQAQ",
        "related_topics": []
      },
      {
        "title": "Vanderbilt Ready to Lead in New Model for College Sports",
        "link": "https://vucommodores.com/vanderbilt-ready-to-lead-in-new-model-for-college-sports/",
        "snippet": "NASHVILLE, Tenn. — Vanderbilt Athletics had a total of 36 student-athletes from four sport programs named to the 2024-25 Winter SEC Academic ...",
        "photo_url": "https://vucommodores.com/wp-content/uploads/2025/06/amt-f3b20188c7ebd6e57b99ea4c06bb9f68df081e54-DJI_20250506165546_0008_D-e1749476925477.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iJ0NnNVRjR3N6UzNOdk5IWkRORXR3VFJDUkF4ajhCU2dLTWdNQmNBbw=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T14:15:15.000Z",
        "authors": [],
        "source_url": "https://vucommodores.com",
        "source_name": "Vanderbilt University Athletics",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://vucommodores.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqLAgKIiZDQklTRmdnTWFoSUtFSFoxWTI5dGJXOWtiM0psY3k1amIyMG9BQVAB",
        "related_topics": []
      },
      {
        "title": "Utah’s top high school athletes shine at Deseret News High School Sports Awards",
        "link": "https://www.deseret.com/sports/2025/06/10/utah-high-school-athletes-honored-at-2025-deseret-news-high-school-sports-awards/",
        "snippet": "Nearly 170 athletes were honored at the third annual Deseret News High School Sports Awards presented by The Larry H. Miller Company. The event, ...",
        "photo_url": "https://www.deseret.com/resizer/v2/RMDBBTLBQNALTBM6U6JDUYDG7M.JPG?auth=1544360c580abf6b4b2ca5141c45e10943e520ab44d6660a5a5567b759e90b77&focal=0%2C0&width=800&height=560",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNXhVRUUwWm1veFYyUktibGxSVFJDOEFSaU1BaWdCTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T06:06:11.000Z",
        "authors": [
          "Krysyan Edler"
        ],
        "source_url": "https://www.deseret.com",
        "source_name": "Deseret News",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://www.deseret.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJQgKIh9DQklTRVFnTWFnMEtDMlJsYzJWeVpYUXVZMjl0S0FBUAE",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZyTkhCME5qUnFlQklDWlc0b0FBUAE",
            "topic_name": "Krysyan Edler"
          }
        ]
      },
      {
        "title": "ASU professors reflect on the pope’s connection to sports and humanity",
        "link": "https://news.asu.edu/20250609-local-national-and-global-affairs-asu-professors-reflect-popes-connection-sports-and",
        "snippet": "So what does it mean to have a U.S. sports fan as pope, and how might he incorporate humanity's love for sports into his religious teachings?",
        "photo_url": "https://news.asu.edu/sites/default/files/styles/block_image_16_9_lge/public/2025-06/iStock-2214274820.jpg?itok=GYGywJgZ",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNVhlVlV0TWtZdFprUTFjekF0VFJDb0FSaXNBaWdCTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T18:14:49.000Z",
        "authors": [],
        "source_url": "https://news.asu.edu",
        "source_name": "ASU News",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://news.asu.edu&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJggKIiBDQklTRWdnTWFnNEtERzVsZDNNdVlYTjFMbVZrZFNnQVAB",
        "related_topics": []
      },
      {
        "title": "Jordan Domineck Joins Athlon Sports as College Football Reporter",
        "link": "https://sports.yahoo.com/article/jordan-domineck-joins-athlon-sports-011323695.html",
        "snippet": "Former Colorado Buffaloes linebacker Jordan Domineck joins Athlon Sports as a reporter covering various schools, including Colorado and Georgia ...",
        "photo_url": "https://s.yimg.com/ny/api/res/1.2/MF8bJvZnjls88Y3z4vVWOQ--/YXBwaWQ9aGlnaGxhbmRlcjt3PTY0MDtoPTQyNztjZj13ZWJw/https://media.zenfs.com/en/athlon_sports_articles_610/fd18b04ebcf47d60506eb50ba4a88d3b",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iMkNnNDFTa0kyZVUxc1dsRnVZMVZrVFJDckF4aUFCU2dLTWd1QklZN0NuQ2ZRSmZ0U2JB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T03:09:11.000Z",
        "authors": [
          "Jeff Hauser"
        ],
        "source_url": "https://sports.yahoo.com",
        "source_name": "Yahoo Sports",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://sports.yahoo.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqLAgKIiZDQklTRmdnTWFoSUtFSE53YjNKMGN5NTVZV2h2Ynk1amIyMG9BQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZuWW1jMGVXNHpkQklDWlc0b0FBUAE",
            "topic_name": "Jeff Hauser"
          }
        ]
      },
      {
        "title": "Maine Athletics announces 2025 UMaine Sports Hall of Fame Class - University of Maine Athletics",
        "link": "https://goblackbears.com/news/2025/6/9/maine-athletics-announces-2025-umaine-sports-hall-of-fame-class.aspx",
        "snippet": "Maine took the Yankee Conference outdoor titles five straight years from 1961 through '65. The 2025 UMaine Sports Hall of Fame class brings the ...",
        "photo_url": "https://goblackbears.com/images/2019/5/1/Sports_Hall_of_Fame_2019.png",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNXRWVmRtWmxwRmNEUndNVEJxVFJDZkF4ampCU2dLTWdZQk1ad2psd28=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T17:15:43.000Z",
        "authors": [],
        "source_url": "https://goblackbears.com",
        "source_name": "University of Maine Athletics",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://goblackbears.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqLAgKIiZDQklTRmdnTWFoSUtFR2R2WW14aFkydGlaV0Z5Y3k1amIyMG9BQVAB",
        "related_topics": []
      },
      {
        "title": "Sioux City City Council approves to sell land for new sports complex, discusses new fireworks ordinance",
        "link": "https://www.ktiv.com/2025/06/10/sioux-city-city-council-approves-sell-land-new-sports-complex-discusses-new-fireworks-ordinance/",
        "snippet": "Sioux City City Councilvoted to approve the sale of 3400 Line Drive to Siouxland Developers, LLC for $50000.",
        "photo_url": "https://gray-ktiv-prod.gtv-cdn.com/resizer/v2/SK6YBDOHQZEGLAYSV7SJYQPJBY.png?auth=03f68687cdbe638ceeb1c1dcce5c11cbb03c8edd1edb2e8ee05a910e2a4be354&width=1200&height=600&smart=true",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNXdMVTlEV0d0SlkzaG9VMmQwVFJDSEF4aVBCaWdLTWdZcFJKTE9vUWs=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T02:44:00.000Z",
        "authors": [
          "Acacia Phillips"
        ],
        "source_url": "https://www.ktiv.com",
        "source_name": "KTIV",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.ktiv.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIQgKIhtDQklTRGdnTWFnb0tDR3QwYVhZdVkyOXRLQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEYwTkhsbWRHWnVPQklDWlc0b0FBUAE",
            "topic_name": "Acacia Phillips"
          }
        ]
      },
      {
        "title": "Peekskill Sports Roundup",
        "link": "https://peekskillherald.com/27559/news/peekskill-sports-roundup-10/",
        "snippet": "Covering June 2-8, 2025: Spring Track and Spotlight of the Week.",
        "photo_url": "https://peekskillherald.com/wp-content/uploads/2025/06/Lead-photo-5-1200x640.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iL0NnNXFhMGhTTTJSVk4yMHdaMUUzVFJDVUF4ajJCU2dLTWdrQkVKU3RvV2NkcFFJ=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T21:14:43.000Z",
        "authors": [
          "Jeffrey Merchan"
        ],
        "source_url": "https://peekskillherald.com",
        "source_name": "Peekskill Herald",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://peekskillherald.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMAgKIipDQklTR1FnTWFoVUtFM0JsWld0emEybHNiR2hsY21Gc1pDNWpiMjBvQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZzWTNGamVYSnNNQklDWlc0b0FBUAE",
            "topic_name": "Jeffrey Merchan"
          }
        ]
      },
      {
        "title": "CAA Sports 2024-25 Year In Review: Fall Championships",
        "link": "https://caasports.com/news/2025/6/9/general-caa-sports-2024-25-year-in-review-fall-championships.aspx",
        "snippet": "Delaware edged Monmouth, 4-3 in overtime, to take home the CAA Field Hockey Championship for the 10th time in the past 12 years. Lulu Fulton ...",
        "photo_url": "https://caasports.com/common/controls/image_handler.aspx?thumb_id=13&image_path=/images/2025/6/9/caachamps_1.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNTRXRTAzTW1wSU1EQkhUV1ZRVFJDM0FSaVRBaWdCTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T15:20:43.000Z",
        "authors": [
          "Rob Washburn"
        ],
        "source_url": "https://caasports.com",
        "source_name": "Coastal Athletic Association (CAA",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://caasports.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKAgKIiJDQklTRXdnTWFnOEtEV05oWVhOd2IzSjBjeTVqYjIwb0FBUAE",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZtTmpoZmFEUTJOeElDWlc0b0FBUAE",
            "topic_name": "Rob Washburn"
          }
        ]
      },
      {
        "title": "Winners and losers from house v. NCAA: amateurism ends as college sports’ class divide widens",
        "link": "https://www.news9.com/story/6847230923fe1908fe275383/winners-and-losers-from-house-v-ncaa-amateurism-ends-as-college-sports-class-divide-widens",
        "snippet": "The House v. NCAA settlement marks a seismic shift in college athletics. Monday, June 9th 2025, 2:55 pm. By: CBS Sports. NCAA headquarters in Indianapolis.",
        "photo_url": "https://viking-image.imgix.net/kwtv/production/2025/June/9/-ncaa-headquarters-in-indianapolis.1749492405805.webp?w=1050&h=590.617&fit=crop",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNU5lbGRVVmxaTVFtNVJhSFZ4VFJDZkF4amlCU2dLTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T19:55:55.000Z",
        "authors": [],
        "source_url": "https://www.news9.com",
        "source_name": "News 9",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://www.news9.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIggKIhxDQklTRHdnTWFnc0tDVzVsZDNNNUxtTnZiU2dBUAE",
        "related_topics": []
      },
      {
        "title": "Vermont H.S. playoff sports scores for Monday, June 9: See how your favorite team fared",
        "link": "https://www.burlingtonfreepress.com/story/sports/high-school/varsityinsider/2025/06/09/vermont-high-school-playoff-sports-scores-for-monday-june-9-baseball-softball-lacrosse-tennis/84111018007/",
        "snippet": "The 2025 Vermont high school spring playoffs have begun. See below for scores, schedules and game details (statistical leaders, ...",
        "photo_url": "https://www.burlingtonfreepress.com/gcdn/authoring/authoring-images/2025/05/09/PBUR/83525237007-p-1010189.JPG?crop=3995,2250,x3,y107&width=660&height=371&format=pjpg&auto=webp",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNTZPUzFmY1dSTFp6WTBkRWxZVFJEekFoaVVCU2dLTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T18:25:36.000Z",
        "authors": [
          "Judith Altneu",
          "Alex Abrami"
        ],
        "source_url": "https://www.burlingtonfreepress.com",
        "source_name": "Burlington Free Press",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.burlingtonfreepress.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqNQgKIi9DQklTSFFnTWFoa0tGMkoxY214cGJtZDBiMjVtY21WbGNISmxjM011WTI5dEtBQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEYwZDJwaWJuWmlheElDWlc0b0FBUAE",
            "topic_name": "Judith Altneu"
          },
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZ0ZG5SdWVURnhlaElDWlc0b0FBUAE",
            "topic_name": "Alex Abrami"
          }
        ]
      },
      {
        "title": "Hounds prep for RTR matchup",
        "link": "https://www.nujournal.com/sports/local-sports/2025/06/10/hounds-prep-for-rtr-matchup/",
        "snippet": "The Greyhounds, champions of Section 2A, will meet 19-7 Russell-Tyler-Ruthton, the champions of Section 3A, at 10:30 a.m. Wednesday. Cathedral ...",
        "photo_url": "https://ogden_images.s3.amazonaws.com/www.nujournal.com/images/2025/06/09231551/Cathedral-851x840.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNUJhSGRFUW05bFlqTXdkRmw1VFJDbUJCaXRCQ2dLTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T05:15:12.000Z",
        "authors": [
          "Jim Bastian"
        ],
        "source_url": "https://www.nujournal.com",
        "source_name": "nujournal.com",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.nujournal.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKAgKIiJDQklTRXdnTWFnOEtEVzUxYW05MWNtNWhiQzVqYjIwb0FBUAE",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEYzY0hRek1YaGlPQklDWlc0b0FBUAE",
            "topic_name": "Jim Bastian"
          }
        ]
      },
      {
        "title": "There’s a New NIL Enforcement Entity in College Sports. It’s Not the NCAA",
        "link": "https://frontofficesports.com/theres-a-new-nil-enforcement-body-in-college-sports-its-not-the-ncaa/",
        "snippet": "The College Sports Commission will enforce the terms of the House v. NCAA settlement, including running the new NIL clearinghouse.",
        "photo_url": "https://frontofficesports.com/wp-content/uploads/2025/06/USATSI_25821264_168416386_lowres-scaled-e1749487125830.jpg?quality=100",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNVFlRW96TUZRMmVrRjZjREJUVFJDZ0F4amlCU2dLTWdZaEk0YVBGUW8=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T16:41:52.000Z",
        "authors": [
          "Amanda Christovich"
        ],
        "source_url": "https://frontofficesports.com",
        "source_name": "Front Office Sports",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://frontofficesports.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMggKIixDQklTR3dnTWFoY0tGV1p5YjI1MGIyWm1hV05sYzNCdmNuUnpMbU52YlNnQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZtTUhnek1uUXpiaElDWlc0b0FBUAE",
            "topic_name": "Amanda Christovich"
          }
        ]
      },
      {
        "title": "Al-Hilal try to splash transfer cash before Club World Cup, but struggle to land stars as tournament nears",
        "link": "https://www.cbssports.com/soccer/news/al-hilal-try-to-splash-transfer-cash-before-club-world-cup-but-struggle-to-land-stars-as-tournament-nears/",
        "snippet": "Names like Bruno Fernandes, Victor Osimhen and Theo Hernandez have thus far turned down big Saudi Arabian offers.",
        "photo_url": "https://sportshub.cbsistatic.com/i/r/2025/06/09/c9816789-b7dd-4942-bb47-aa6fd19e60c5/thumbnail/1200x675/3d7524d7a07bdb333eb51acb853e2601/untitled-design-2025-06-09t191047-825.png",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNXVka3AyVTFwdFR6bFpjV04yVFJDZkF4ampCU2dLTWdhcEpKU09HUW8=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T17:51:00.000Z",
        "authors": [
          "James Benge"
        ],
        "source_url": "https://www.cbssports.com",
        "source_name": "CBS Sports",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.cbssports.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKAgKIiJDQklTRXdnTWFnOEtEV05pYzNOd2IzSjBjeTVqYjIwb0FBUAE",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZtZVRWcmNYbDNlUklDWlc0b0FBUAE",
            "topic_name": "James Benge"
          }
        ]
      },
      {
        "title": "Tremendous comeback for Class A first-team, all-state captain",
        "link": "https://www.newsandsentinel.com/sports/local-sports/2025/06/tremendous-comeback-for-class-a-first-team-all-state-captain/",
        "snippet": "Pendleton County's Baylee Beachler saw her 2024 campaign come to an end after tearing a tendon in her shoulder at the end of that regular ...",
        "photo_url": "https://ogden_images.s3.amazonaws.com/www.newsandsentinel.com/images/2025/06/09210735/06-10-25-Class-A-Softball-tle-1100x733.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNXdaVTB0UVZVNFFsOWpRVzlKVFJERUF4aW1CU2dLTWdhbElKU3RtUWs=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T04:05:29.000Z",
        "authors": [
          "Tyler Jackson"
        ],
        "source_url": "https://www.newsandsentinel.com",
        "source_name": "News and Sentinel",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://www.newsandsentinel.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMAgKIipDQklTR1FnTWFoVUtFMjVsZDNOaGJtUnpaVzUwYVc1bGJDNWpiMjBvQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZ3TURGeGNXeGZOQklDWlc0b0FBUAE",
            "topic_name": "Tyler Jackson"
          }
        ]
      },
      {
        "title": "Elevate Opens $500M College Sports Fund With Texas PSF, Velocity",
        "link": "https://www.sportico.com/business/finance/2025/elevate-college-investment-velocity-texas-permanent-school-1234855451/",
        "snippet": "Sports agency Elevate launches a $500 million investment fund for college sports, backed by the Texas Permanent School Fund and Velocity ...",
        "photo_url": "https://www.sportico.com/wp-content/uploads/2025/06/Elevate_Stadium2.png?w=1280&h=720&crop=1",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNWpRVkJZUkRFMWRrMVVYMHBZVFJDZkF4ampCU2dLTWdZUm9aQXBPUVk=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T12:01:17.000Z",
        "authors": [
          "Brendan Coffey"
        ],
        "source_url": "https://www.sportico.com",
        "source_name": "Sportico.com",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.sportico.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJggKIiBDQklTRWdnTWFnNEtESE53YjNKMGFXTnZMbU52YlNnQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZuT1hJM056WjBOeElDWlc0b0FBUAE",
            "topic_name": "Brendan Coffey"
          }
        ]
      },
      {
        "title": "It's not the game, it's the group: Sports fans connect the most over rituals",
        "link": "https://phys.org/news/2025-06-game-group-sports-fans-rituals.html",
        "snippet": "The scientists outfitted participants with EKG monitors hidden beneath their clothing. The devices measured heart rate fluctuations, which is a ...",
        "photo_url": "https://scx2.b-cdn.net/gfx/news/hires/2021/soccer-fan.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iL0NnNVVRVU0wUm5CR1ExbFBiMFYyVFJERUF4aW1CU2dLTWdtTmtJaUh0dVVscmdF=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T19:00:08.000Z",
        "authors": [
          "Sadie Marie Harley"
        ],
        "source_url": "https://phys.org",
        "source_name": "Phys.org",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://phys.org&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIQgKIhtDQklTRGdnTWFnb0tDSEJvZVhNdWIzSm5LQUFQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEY1TWpkdWMyMXlaQklDWlc0b0FBUAE",
            "topic_name": "Sadie Marie Harley"
          }
        ]
      },
      {
        "title": "First women's sports bar in San Francisco opens this week",
        "link": "https://www.nbcbayarea.com/news/local/womens-sports-bar-san-francisco/3887928/",
        "snippet": "A women's sports bar is coming to San Francisco. Rikki's on Market Street will officially open its doors on Wednesday. Watch NBC Bay Area ...",
        "photo_url": "https://media.nbcbayarea.com/2025/06/40101267510-1080pnbcstations.jpg?quality=85&strip=all&resize=1200%2C675",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNVhXR2MwTFRKRmFVOVFaelZYVFJDZkF4ampCU2dLTWdhQlFKUWxxZ2M=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T17:38:29.000Z",
        "authors": [],
        "source_url": "https://www.nbcbayarea.com",
        "source_name": "NBC Bay Area",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://www.nbcbayarea.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKQgKIiNDQklTRkFnTWFoQUtEbTVpWTJKaGVXRnlaV0V1WTI5dEtBQVAB",
        "related_topics": []
      },
      {
        "title": "WVSWA Releases W.Va. Class AA Softball All-State Teams",
        "link": "https://www.theintelligencer.net/sports/top-sports/2025/06/wvswa-releases-w-va-class-aa-softball-all-state-teams/",
        "snippet": "Golden Bears sophomore Mattie Carney captains the Class AA all-state first team, as selected by the West Virginia Sports Writers Association, ...",
        "photo_url": "https://ogden_images.s3.amazonaws.com/www.theintelligencer.net/images/2025/06/10002316/Mattie-Carney-376x300.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNUNNVk5OWjA1T2NHMXhSRVJJVFJDc0FoajRBaWdLTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T04:35:53.000Z",
        "authors": [],
        "source_url": "https://www.theintelligencer.net",
        "source_name": "theintelligencer.net",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://www.theintelligencer.net&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMQgKIitDQklTR2dnTWFoWUtGSFJvWldsdWRHVnNiR2xuWlc1alpYSXVibVYwS0FBUAE",
        "related_topics": []
      },
      {
        "title": "Songprasert Named the Texas Panhandle Sports Hall of Fame Golfer of the Year",
        "link": "https://gobuffsgo.com/news/2025/6/9/womens-golf-songprasert-named-the-texas-panhandle-sports-hall-of-fame-golfer-of-the-year.aspx",
        "snippet": "The Chiang Mai, Thailand native recorded a win at the WT West Region Preview with six additional top five finishes during her senior campaign.",
        "photo_url": "https://gobuffsgo.com/images/2025/6/9/Sonprasert_NCAA.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNTFSRkJZVFU1RVJqWnhUbFZhVFJDb0FSaXNBaWdCTWdZbEJvcnNrUWs=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T15:30:17.000Z",
        "authors": [],
        "source_url": "https://gobuffsgo.com",
        "source_name": "West Texas A&M University Athletics",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://gobuffsgo.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKAgKIiJDQklTRXdnTWFnOEtEV2R2WW5WbVpuTm5ieTVqYjIwb0FBUAE",
        "related_topics": []
      },
      {
        "title": "With $2.7 billion settlement approved, college sports' big money era is officially here",
        "link": "https://www.npr.org/2025/06/06/nx-s1-5426123/ncaa-settlement-deal-athlete-compensation-judge",
        "snippet": "Starting this fall, colleges and universities in the NCAA's top division will be allowed to directly pay athletes for the first time. Payments ...",
        "photo_url": "https://npr.brightspotcdn.com/dims3/default/strip/false/crop/3969x2646+0+0/resize/1100/quality/50/format/jpeg/?url=http%3A%2F%2Fnpr-brightspot.s3.amazonaws.com%2F5e%2F9f%2Fb3e3538d45088b6bbbd1e44f3374%2Fncaa.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iL0NnNUdlVlUxWldSQ1RuVkhUa2hqVFJERUF4aW1CU2dLTWdtZGdZaHNNZWcxOHdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-07T02:47:33.000Z",
        "authors": [
          "Becky Sullivan"
        ],
        "source_url": "https://www.npr.org",
        "source_name": "NPR",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://www.npr.org&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIAgKIhpDQklTRFFnTWFna0tCMjV3Y2k1dmNtY29BQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZ4Ym1NNFh6Um5OUklDWlc0b0FBUAE",
            "topic_name": "Becky Sullivan"
          }
        ]
      },
      {
        "title": "Familiar Script: WVU two-and-out in super regional",
        "link": "https://www.newsandsentinel.com/sports/local-sports/2025/06/familiar-script-wvu-two-and-out-in-super-regional/",
        "snippet": "LSU blew the game open early with five runs in the second inning, all after West Virginia starter Jack Kartsonas retired the first two batters ...",
        "photo_url": "https://ogden_images.s3.amazonaws.com/www.newsandsentinel.com/images/2025/06/09210830/06-10-25-WVU-BB-tle-1-840x840.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNXdTaTFVYUdORFFuRTBWbVJJVFJDcUJCaXFCQ2dLTWdhVkpKS09GUW8=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T04:06:06.000Z",
        "authors": [],
        "source_url": "https://www.newsandsentinel.com",
        "source_name": "News and Sentinel",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://www.newsandsentinel.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMAgKIipDQklTR1FnTWFoVUtFMjVsZDNOaGJtUnpaVzUwYVc1bGJDNWpiMjBvQUFQAQ",
        "related_topics": []
      },
      {
        "title": "India face Hong Kong in crunch AFC Asian Cup qualifier: Indian Sports LIVE, June 10",
        "link": "https://www.espn.com/espn/story/_/id/45479901/india-face-hong-kong-crunch-afc-asian-cup-qualifier-ultimate-table-tennis-indian-sports-live-june-10",
        "snippet": "What's on today? Football: India face Hong Kong in a crunch AFC Asian Cup qualifier. Table-tennis: The Ultimate Table Tennis league continues.",
        "photo_url": "https://a.espncdn.com/photo/2025/0318/r1466080_1165x655_16-9.png",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNDVaRlZxT0VaVGVEQkxjRlJRVFJDZkF4ampCU2dLTWdZcE5ZcXVtUWs=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T02:30:00.000Z",
        "authors": [],
        "source_url": "https://www.espn.com",
        "source_name": "ESPN",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.espn.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqIQgKIhtDQklTRGdnTWFnb0tDR1Z6Y0c0dVkyOXRLQUFQAQ",
        "related_topics": []
      },
      {
        "title": "Power conferences hiring MLB exec to lead enforcement of new era as College Sports Commission CEO",
        "link": "https://www.nytimes.com/athletic/6409170/2025/06/06/bryan-seeley-college-sports-commission-ceo/",
        "snippet": "The Power conferences will bring in an MLB executive to guide the schools through a post-House settlement era.",
        "photo_url": "https://static01.nyt.com/athletic/uploads/wp/2025/06/06160930/USATSI_11792059-scaled-e1749240600939.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNXVhMjlYTWtaU2FuSnRaSHBzVFJERUF4aW1CU2dLTWdZbEpwenRHUW8=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-07T05:34:31.000Z",
        "authors": [
          "Ralph D Russo",
          "Evan Drellich"
        ],
        "source_url": "https://www.nytimes.com",
        "source_name": "The New York Times",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.nytimes.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJQgKIh9DQklTRVFnTWFnMEtDMjU1ZEdsdFpYTXVZMjl0S0FBUAE",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZ5Ympaa01IcGpjUklDWlc0b0FBUAE",
            "topic_name": "Ralph D Russo"
          },
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZtTldnM1gyNDFkQklDWlc0b0FBUAE",
            "topic_name": "Evan Drellich"
          }
        ]
      },
      {
        "title": "Southern Baptists target porn, sports betting, same-sex marriage and 'willful childlessness'",
        "link": "https://abcnews.go.com/US/wireStory/southern-baptists-target-porn-sports-betting-same-sex-122646173",
        "snippet": "The proposed resolutions call for laws on gender, marriage and family based on what they say is the biblically stated order of divine creation.",
        "photo_url": "https://s.abcnews.com/images/US/wirestory_aac48e558ea4b7f1c3b869b917e6eea2_16x9_1600.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iJ0NnNVNPVmxXY21sRFRFOTRWa2sxVFJDZkF4ampCU2dLTWdNQmtBbw=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T11:22:52.000Z",
        "authors": [
          "Peter Jesserer Smith"
        ],
        "source_url": "https://abcnews.go.com",
        "source_name": "ABC News",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://abcnews.go.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKQgKIiNDQklTRkFnTWFoQUtEbUZpWTI1bGQzTXVaMjh1WTI5dEtBQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZzWjNJemN6STBjeElDWlc0b0FBUAE",
            "topic_name": "Peter Jesserer Smith"
          }
        ]
      },
      {
        "title": "The 2024-25 Austin Area High School Sports Awards show winners",
        "link": "https://www.statesman.com/story/sports/high-school/sports-awards/2025/06/09/austin-area-high-school-sports-awards-winners-list/83577726007/",
        "snippet": "The 2024-25 Austin Area High School Sports Awards, Presented by Thomas J. Henry Law, were on Monday night at The Long Center -- Dell Hall.",
        "photo_url": "https://www.statesman.com/gcdn/authoring/authoring-images/2025/04/02/SHSS/82768719007-sa-25-presto-generic-austin-area-1.jpg?width=660&height=372&fit=crop&format=pjpg&auto=webp",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iI0NnNXRaWGRLTlRGNU1tcFdkRUUxVFJEMEFoaVVCU2dLTWdB=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T01:59:13.000Z",
        "authors": [
          "Austin American"
        ],
        "source_url": "https://www.statesman.com",
        "source_name": "Austin American-Statesman",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn1.gstatic.com/faviconV2?url=https://www.statesman.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKAgKIiJDQklTRXdnTWFnOEtEWE4wWVhSbGMyMWhiaTVqYjIwb0FBUAE",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZ5YUhNMVluazRhQklDWlc0b0FBUAE",
            "topic_name": "Austin American"
          }
        ]
      },
      {
        "title": "Donald Trump to meet with key college sports decision-makers in golf outing where they'll discuss industry's future",
        "link": "https://sports.yahoo.com/college-football/article/donald-trump-to-meet-with-key-college-sports-decision-makers-in-golf-outing-where-theyll-discuss-industrys-future-134037159.html",
        "snippet": "Notre Dame athletic director Pete Bevacqua and SEC commissioner Greg Sankey are planning to golf with the president at Trump National Golf Club ...",
        "photo_url": "https://s.yimg.com/ny/api/res/1.2/ZrfaqTfAW7sMRE3IqxlJlg--/YXBwaWQ9aGlnaGxhbmRlcjt3PTY0MDtoPTQyNztjZj13ZWJw/https://s.yimg.com/os/creatr-uploaded-images/2025-06/2927b8d0-43eb-11f0-be59-9d14878b073a",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iL0NnNVFPVjg1UmpOeFZrRmFNalIzVFJDckF4aUFCU2dLTWdtQlVwcUdwdWhFU0FJ=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-08T13:41:39.000Z",
        "authors": [
          "Ross Dellenger"
        ],
        "source_url": "https://sports.yahoo.com",
        "source_name": "Yahoo Sports",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://sports.yahoo.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqLAgKIiZDQklTRmdnTWFoSUtFSE53YjNKMGN5NTVZV2h2Ynk1amIyMG9BQVAB",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZtZVhsa2RIQnRYeElDWlc0b0FBUAE",
            "topic_name": "Ross Dellenger"
          }
        ]
      },
      {
        "title": "How a Maple Grove senior is excelling in 3 sports",
        "link": "https://www.cbsnews.com/minnesota/video/how-a-maple-grove-senior-is-excelling-in-3-sports/",
        "snippet": null,
        "photo_url": "https://assets2.cbsnewsstatic.com/hub/i/r/2025/06/09/ef94a0fc-6039-4e35-a325-6ad1f9c7e80a/thumbnail/640x360/194bd7481e27218972d7bc367b75679a/ed9751106642456b3771e6f71607a890.jpg?v=47da7f60d670305b40b7371b438c2af0",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNXRSRko1ZVZWQmIzbG5RbWd4VFJEb0FoaUFCU2dLTWdZQlVJU0g0Z0k=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T01:29:00.000Z",
        "authors": [],
        "source_url": "https://www.cbsnews.com",
        "source_name": "CBS News",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn0.gstatic.com/faviconV2?url=https://www.cbsnews.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqJQgKIh9DQklTRVFnTWFnMEtDMk5pYzI1bGQzTXVZMjl0S0FBUAE",
        "related_topics": []
      },
      {
        "title": "VOTE for the North Jersey HS Sports Team of the Week for June 2-8",
        "link": "https://www.northjersey.com/story/sports/high-school/2025/06/09/vote-north-jersey-hs-sports-team-of-the-week-june-2-8/84113330007/",
        "snippet": "After a thrilling penultimate week of the spring high school sports season, it's time to look back on the top team performances.",
        "photo_url": "https://www.northjersey.com/gcdn/authoring/authoring-images/2025/06/07/PNJM/84093619007-060725-ffb-ridgewood-secaucus-002.JPG?crop=3747,2108,x3,y75&width=660&height=371&format=pjpg&auto=webp",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iL0NnNXlOMngxUVhWUGNqZEdVRkJSVFJEekFoaVVCU2dLTWdrQk1JcDBIR3F4N1FF=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-09T17:31:31.000Z",
        "authors": [
          "Zach Miller"
        ],
        "source_url": "https://www.northjersey.com",
        "source_name": "Bergen Record",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn2.gstatic.com/faviconV2?url=https://www.northjersey.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqKggKIiRDQklTRlFnTWFoRUtEMjV2Y25Sb2FtVnljMlY1TG1OdmJTZ0FQAQ",
        "related_topics": [
          {
            "topic_id": "CAAqKAgKIiJDQkFTRXdvTkwyY3ZNVEZzWjNJMU5IWm9hQklDWlc0b0FBUAE",
            "topic_name": "Zach Miller"
          }
        ]
      },
      {
        "title": "What to watch for in WPIAL sports on June 10, 2025: North Allegheny, Shaler set for boys volleyball state semifinals",
        "link": "https://tribhssn.triblive.com/what-to-watch-for-in-wpial-sports-on-june-10-2025-north-allegheny-shaler-set-for-boys-volleyball-state-semifinals/",
        "snippet": "In the PIAA postseason, North Allegheny has ousted Palmyra and Penn-Trafford while Central York has knocked off Seneca Valley and Spring-Ford.",
        "photo_url": "https://assets-tribhssn.triblive.com/2025/06/8580780_web1_ptr-NAPal03-060425.jpg",
        "thumbnail_url": "https://news.google.com/api/attachments/CC8iK0NnNUhRa1ZPWldSUFlqRm1UVk5CVFJEN0F4amRCQ2dLTWdhRk1JcVd1QVU=-w200-h200-p-df-rw",
        "published_datetime_utc": "2025-06-10T00:48:10.000Z",
        "authors": [],
        "source_url": "https://tribhssn.triblive.com",
        "source_name": "Trib HSSN",
        "source_logo_url": null,
        "source_favicon_url": "https://encrypted-tbn3.gstatic.com/faviconV2?url=https://tribhssn.triblive.com&client=NEWS_360&size=96&type=FAVICON&fallback_opts=TYPE,SIZE,URL",
        "source_publication_id": "CAAqMggKIixDQklTR3dnTWFoY0tGWFJ5YVdKb2MzTnVMblJ5YVdKc2FYWmxMbU52YlNnQVAB",
        "related_topics": []
      }
    ]
  }
}
